module.exports = __webpack_public_path__ + "logo.png?f364e2349b7da0c112cf6281db6ed79f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 213
// module chunks = 0